export const EVENT_CHANNEL_DEFAULT_TOPIC = "DEFAULTTOPIC";
